/**
 * Dev-only logger. In production builds (NODE_ENV !== "development") every
 * call here is a no-op, so we don't leak internal messages or pay the
 * console-formatting cost on real users' browsers.
 *
 * Usage:
 *   import { log } from "../lib/log";
 *   log.warn("[auth] localStorage unavailable:", e?.message);
 *
 * The shape matches the methods we actually use across the app — `warn`,
 * `error`, `info`, `debug`. We *don't* expose `log.log` because that's the
 * pattern most code-review tools flag.
 */
const isDev = typeof process !== "undefined" && process.env?.NODE_ENV !== "production";

const noop = () => {};

export const log = isDev
  ? {
      warn: (...args) => console.warn(...args),
      error: (...args) => console.error(...args),
      info: (...args) => console.info(...args),
      debug: (...args) => console.debug(...args),
    }
  : {
      warn: noop,
      error: noop,
      info: noop,
      debug: noop,
    };
